// Event edit page (comp-ε GAP-3b-ii-b, CHG-2450).
//
// Thin route wrapper at /events/:eventId/edit. Fetches the event, then renders
// the canonical EventFormDialog (mode=edit) prefilled from the record. The
// FormDialog is a full-viewport overlay; the page provides the
// <main role="main"> landmark. On save or cancel the route returns to the
// event detail page.
//
// Spec: specs/tier-05-experience/event-detail-v2.cross-screen.yaml.

import { useQuery } from "@tanstack/react-query";
import { useNavigate, useParams } from "react-router-dom";
import { eventsApi } from "../api/events";
import { EventFormDialog } from "../components/events/EventFormDialog";

export function EventEdit() {
  const navigate = useNavigate();
  const { eventId = "" } = useParams<{ eventId: string }>();
  const detailPath = `/events/${eventId}`;

  const {
    data: event,
    isLoading,
    isError,
  } = useQuery({
    queryKey: ["events", "detail", eventId] as const,
    queryFn: () => eventsApi.getEvent(eventId),
    enabled: Boolean(eventId),
  });

  if (isLoading) {
    return (
      <main role="main" style={{ padding: 24 }}>
        <p style={{ fontSize: 13, color: "var(--color-text-muted)" }}>
          Loading event…
        </p>
      </main>
    );
  }

  if (isError || !event) {
    return (
      <main role="main" style={{ padding: 24 }}>
        <div
          role="alert"
          className="card"
          style={{ padding: 16, fontSize: 13, color: "var(--color-error)" }}
        >
          Could not load this event.
        </div>
      </main>
    );
  }

  return (
    <main role="main">
      <EventFormDialog
        mode="edit"
        event={event}
        onClose={() => navigate(detailPath)}
        onSaved={() => navigate(detailPath)}
      />
    </main>
  );
}
